
import React from "react";
import { LegalListModule } from "../modules/legal/LegalListModule";
import { contractModuleConfig } from "../modules/legal/config/ContractModuleConfig";
import { useAuth } from "../context/AuthContext";
import { canEditModule } from "../config/roles";

export function ContractsPage() {
  const { user } = useAuth();
  const canEdit = user ? canEditModule(user.role, 'CONTRACTS') : false;

  // Override canEdit in config dynamically
  const config = {
      ...contractModuleConfig,
      canEdit: canEdit
  };

  return <LegalListModule config={config} />;
}
